import AddMenu from './AddMenu'

export default AddMenu
